// @flow

export const PLUGIN_NAME = 'trix-web-plugin-dialogue-host';
